<template>
  <div id="contenedor-excel-obras">
    <v-card v-if="$apollo.loading || !datosListos">
      <v-container>
        <v-row
          class="fill-height"
          align-content="center"
          justify="center"
        >
          <v-col
            class="text-subtitle-1 text-center"
            cols="12"
          >
            Preparando exportación de Obras...
          </v-col>
          <v-col cols="6">
            <v-progress-linear
              color="primary"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-form
      v-else
      ref="exportarExcelObras"
      v-model="formularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Exportar Obras
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-radio-group
            v-model="seleccion"
            mandatory>
            <v-radio
              value="listadoActual">
              <template v-slot:label>
                <div>
                  <strong class="secondary--text">Listado Actual</strong>
                </div>
              </template>
            </v-radio>
            <!-- <v-radio
              value="rangoFechas">
              <template v-slot:label>
                <div>
                  <strong class="secondary--text">Rango de Fechas (de contrato)</strong>
                </div>
              </template>
            </v-radio> -->
          </v-radio-group>
          <v-row v-if="seleccion === 'rangoFechas'">
            <custom-date-picker
              v-model="rangoFechas.inicial"
              :rules="[mixReglas.requerido]"
              label="Fecha Inicial">
            </custom-date-picker>
            <custom-date-picker
              v-model="rangoFechas.final"
              :rules="[mixReglas.requerido]"
              label="Fecha Final">
            </custom-date-picker>
          </v-row>
          <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            label="Exportar"
            tipo="formAceptar"
            :disabled="!formularioValido"
            :loading="estaCargando"
            @click="generarExcelObras">
          </custom-button>
        </v-card-actions>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CONTRATOS_POR_ID_OBRAS from '@/graphql/querys/administracion/contratos/contratosPorIdObras.gql';
import PRESUPUESTOS from '@/graphql/querys/administracion/presupuestos/presupuestos.gql';
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 4;
// const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 1;

export default {
  name: 'ExcelObras',
  mixins: [mixGenerarExceles],
  props: {
    obras: {
      type: Array,
      required: true,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomDatePicker,
    CustomButton,
  },
  apollo: {
    contratosPorIdObras: {
      query: CONTRATOS_POR_ID_OBRAS,
      variables() {
        return {
          idObras: this.obras.map((obra) => obra.id),
        };
      },
      skip() {
        return !this.obras || this.obras.length === 0;
      },
      update(data) {
        return data.contratosPorIdObras;
      },
    },
    presupuestos: {
      query: PRESUPUESTOS,
    },
  },
  data() {
    return {
      formularioValido: false,
      estaCargando: false,
      seleccion: 'listadoActual',
      rangoFechas: {
        inicial: null,
        final: null,
      },
      nombreDocumento: 'CONSULTA GLOBAL DE OBRAS',
      configuracionExcel: {},
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
          wrapText: true,
        },
      },
      headersColumnas: [
        {
          value: 'Ejercicio', nombreColumna: 'ejercicio', orden: 1,
        },
        {
          value: 'Clave', nombreColumna: 'clave', orden: 2,
        },
        {
          value: 'Objeto', nombreColumna: 'objeto', orden: 3,
        },
        {
          value: 'Tipo', nombreColumna: 'tipo', orden: 4,
        },
        {
          value: 'Subtipo', nombreColumna: 'subTipo', orden: 5,
        },
        {
          value: 'Programa', nombreColumna: 'programa', orden: 6,
        },
        {
          value: 'Municipio', nombreColumna: 'municipio', orden: 7,
        },
        {
          value: 'Localidad', nombreColumna: 'localidad', orden: 8,
        },
        {
          value: 'Ubicación', nombreColumna: 'ubicacion', orden: 9,
        },
        {
          value: 'Latitud', nombreColumna: 'latitud', orden: 10,
        },
        {
          value: 'Longitud', nombreColumna: 'longitud', orden: 11,
        },
        {
          value: 'Beneficiados', nombreColumna: 'beneficiados', orden: 12,
        },
        {
          value: 'Unidad Meta Fisica', nombreColumna: 'unidadMetaFisica', orden: 13,
        },
        {
          value: 'Cantidad Meta Fisica', nombreColumna: 'cantidadMetaFisica', orden: 14,
        },
        {
          value: 'Pres. Autorizado', nombreColumna: 'presupuestoAutorizado', orden: 15,
        },
        {
          value: 'Pres. Modificado', nombreColumna: 'presupuestoModificado', orden: 16,
        },
        // {
        //   value: 'Oficios Autorizado', nombreColumna: 'oficiosAutorizado', orden: 17,
        // },
        {
          value: 'Contratado', nombreColumna: 'contratado', orden: 18,
        },
        {
          value: 'Ejercido', nombreColumna: 'ejercido', orden: 19,
        },
        {
          value: 'Pagado', nombreColumna: 'pagado', orden: 20,
        },
        {
          value: '%Av. Prog.', nombreColumna: 'porcentajeAvanceProgramado', orden: 21,
        },
        {
          value: '%Av. Fin.', nombreColumna: 'porcentajeAvanceFinanciero', orden: 22,
        },
        {
          value: '%Av. Fis.', nombreColumna: 'porcentajeAvanceFisico', orden: 23,
        },
      ],
      noData: [{
        ejercicio: '',
        clave: '',
        objeto: '',
        tipo: '',
        subTipo: '',
        programa: '',
        municipio: '',
        localidad: '',
        ubicacion: '',
        latitud: '',
        longitud: '',
        beneficiados: '',
        unidadMetaFisica: '',
        cantidadMetaFisica: '',
        presupuestoAutorizado: '',
        presupuestoModificado: '',
        // oficiosAutorizado: '',
        contratado: '',
        ejercido: '',
        pagado: '',
        porcentajeAvanceProgramado: '',
        porcentajeAvanceFinanciero: '',
        porcentajeAvanceFisico: '',
      }],
      estilos: {
        centrado: {
          alignment: {
            horizontal: 'center',
            vertical: 'center',
          },
        },
        dinero: {
          numberFormat: '$#,##0.00',
        },
      },
    };
  },
  methods: {
    async generarExcelObras() {
      const data = this.crearExcelObras;
      await this.mixGenerarExcel(data);
    },
    cerrar() {
      this.$refs.exportarExcelObras.reset();
      this.rangoFechas.inicial = null;
      this.rangoFechas.final = null;
      this.$emit('cerrar');
    },
    getDatosUltimoReporte(reportesFisicos) {
      const datos = {
        avanceProgramado: '',
        avanceFisico: '',
        avanceFinanciero: '',
        atraso: '',
        fechaUltimoReporte: '',
        ultimoComentario: '',
      };
      if (reportesFisicos.length > 0) {
        const ultimoReporte = reportesFisicos.find((reporte) => reporte.esUltimo);
        datos.avanceProgramado = ultimoReporte.avanceProgramado;
        datos.avanceFisico = ultimoReporte.avanceFisico;
        datos.avanceFinanciero = ultimoReporte.avanceFinanciero;
        datos.atraso = ultimoReporte.avanceProgramado - ultimoReporte.avanceFisico; // verificar
        datos.fechaUltimoReporte = ultimoReporte.fecha;
        datos.ultimoComentario = ultimoReporte.comentarios;
      }
      return datos;
    },
    getSolicitadoPagado(solicitudesPagos) {
      const importesPagadosYSolicitados = solicitudesPagos.map((solicitudPago) => ({
        importeFacturadoSolicitado: this.$ObjSumar(solicitudPago.detalles, 'importe'),
        importeFacturadoPagado: this.$ObjSumar(solicitudPago.detalles.map((solicitudDetalle) => ({
          importePagado: this.$ObjSumar(solicitudDetalle.pagosDetalles, 'importe'),
        })), 'importePagado'),
      }));
      const importeFacturadoSolicitado = this.$ObjSumar(importesPagadosYSolicitados, 'importeFacturadoSolicitado');
      const importeFacturadoPagado = this.$ObjSumar(importesPagadosYSolicitados, 'importeFacturadoPagado');
      // const importeFacturadoPorPagar = importeFacturadoSolicitado - importeFacturadoPagado;

      return {
        importeFacturadoSolicitado,
        importeFacturadoPagado,
        // importeFacturadoPorPagar,
      };
    },
    getImportesEjercidosContrato(contrato) {
      const importeEjercidoContratoAntesIva = this.$ObjSumar(contrato.estimaciones, 'subtotalDos')
      + this.$ObjSumar(contrato.escalatorias, 'importe')
      + this.$ObjSumar(contrato.gastos, 'importe')
      + this.$ObjSumar(contrato.anticipos, 'importe');

      const importeEjercidoContratoIva = this.$ObjSumar(contrato.estimaciones, 'importeIva')
      + this.$ObjSumar(contrato.escalatorias, 'iva')
      + this.$ObjSumar(contrato.gastos, 'iva')
      + this.$ObjSumar(contrato.anticipos, 'iva');

      const importeEjercidoContratoFacturado = importeEjercidoContratoAntesIva
      + importeEjercidoContratoIva;

      return {
        importeEjercidoContratoAntesIva,
        importeEjercidoContratoIva,
        importeEjercidoContratoFacturado,
      };
    },
    getDatosContrato(obra) {
      const contratoId = this.getIdsObrasConContrato
        .find((contrato) => contrato.idObra === obra.id)?.idContrato;
      const sinDatos = {
        presupuestoAutorizado: '',
        presupuestoModificado: '',
        oficiosAutorizado: '',
        contratado: '',
        ejercido: '',
        pagado: '',
        porcentajeAvanceProgramado: '',
        porcentajeAvanceFinanciero: '',
        porcentajeAvanceFisico: '',
      };
      if (!contratoId) return sinDatos;
      const contratoObra = this.getContratos.find((contrato) => contrato.id === contratoId);
      return {
        presupuestoAutorizado: this.getDetallesPresupuesto
          .find((detallePresupuesto) => detallePresupuesto.idObra
          === obra.id)?.presupuestoAutorizado || '',
        presupuestoModificado: this.getDetallesPresupuesto
          .find((detallePresupuesto) => detallePresupuesto.idObra
          === obra.id)?.presupuestoModificado || '',
        // oficiosAutorizado: '', // TODO PENDIENTE ASIGNAR OFICIO AUTORIZACION
        contratado: contratoObra.esObraFinanciada
          ? contratoObra.importeCostoDirecto
            + contratoObra.importeCostoIndirectos
            + contratoObra.importeUtilidad
          : contratoObra.importe,
        ejercido: this.getImportesEjercidosContrato(contratoObra).importeEjercidoContratoFacturado,
        pagado: this.getSolicitadoPagado(contratoObra.solicitudesPagos).importeFacturadoPagado,
        porcentajeAvanceProgramado: this.getDatosUltimoReporte(contratoObra.reportesFisicos)
          .avanceProgramado,
        porcentajeAvanceFinanciero: this.getDatosUltimoReporte(contratoObra.reportesFisicos)
          .avanceFinanciero,
        porcentajeAvanceFisico: this.getDatosUltimoReporte(contratoObra.reportesFisicos)
          .avanceFisico,
      };
    },
  },
  computed: {
    datosListos() {
      // Verificar que todas las queries necesarias hayan cargado
      if (this.obras && this.obras.length > 0) {
        // Si hay obras, necesitamos que contratosPorIdObras esté definido
        return this.contratosPorIdObras !== undefined
          && this.presupuestos !== undefined;
      }
      // Si no hay obras, solo necesitamos presupuestos
      return this.presupuestos !== undefined;
    },
    getContratos() {
      if (!this.contratosPorIdObras) return [];
      return this.contratosPorIdObras;
    },
    getPresupuestos() {
      if (!this.presupuestos) return [];
      return this.presupuestos;
    },
    getIdsObrasConContrato() {
      if (this.getContratos.length < 1) return [];
      const obrasConContrato = [];
      this.getContratos.forEach((contrato) => {
        contrato.obras.forEach((obra) => {
          obrasConContrato.push({
            idObra: obra.idObra,
            idContrato: contrato.id,
          });
        });
      });
      return obrasConContrato;
    },
    getObrasTodas() {
      if (this.obras.length < 1) return [];
      return this.obras
        .slice()
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
    },
    getObrasFiltrado() {
      if (!this.obras || this.obras.length < 1) return [];
      if (!this.filtros) return [];
      return this.obras
        .slice()
        .sort((a, b) => (`${a.clave}`).localeCompare(b.clave))
        // Filtrar por Ejercicio
        .filter(({ ejercicio }) => ejercicio === this.filtros.ejercicio)
        // Filtrar por Tipo
        .filter(({ idTipo }) => {
          const { tipos } = this.filtros;
          if (!tipos || tipos.length <= 0) return true;
          return tipos.includes(idTipo);
        })
        // Filtrar por Programa
        .filter(({ idPrograma }) => {
          const { programas } = this.filtros;
          if (!programas || programas.length <= 0) return true;
          return programas.includes(idPrograma);
        })
        // Filtrar por Texto de Busqueda
        .filter((obra) => {
          if (!this.filtros.buscarTexto) return obra;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const clave = obra.clave ? this.$normalizacionTexto(obra.clave) : '';
          const meta = obra.meta ? this.$normalizacionTexto(obra.meta) : '';
          const municipioNombre = (obra.ubicacion
            && obra.ubicacion.municipio
            && obra.ubicacion.municipio.nombre)
            ? obra.ubicacion.municipio.nombre : '';
          const municipio = municipioNombre
            ? this.$normalizacionTexto(municipioNombre) : '';
          const programaNombre = (obra.programa && obra.programa.nombre)
            ? obra.programa.nombre : '';
          const programa = programaNombre
            ? this.$normalizacionTexto(programaNombre) : '';
          return (
            expt.test(clave)
            || expt.test(meta)
            || expt.test(municipio)
            || expt.test(programa)
            || expt.test(obra.clave || '')
            || expt.test(obra.meta || '')
            || expt.test(municipioNombre)
            || expt.test(programaNombre)
          );
        });
    },
    getObrasParaExcel() {
      return this.seleccion === 'listadoActual' ? this.getObrasFiltrado : this.getObrasFiltrado;
    },
    getObrasFormateadasExcel() {
      const obrasFormateadasExcel = this.getObrasParaExcel
        .slice()
        .map((obra) => ({
          ejercicio: obra.ejercicio,
          clave: obra.clave,
          objeto: obra.meta,
          tipo: (obra.tipo && obra.tipo.descripcion) ? obra.tipo.descripcion : '',
          subTipo: (obra.subtipo && obra.subtipo.descripcion) ? obra.subtipo.descripcion : '',
          programa: (obra.programa && obra.programa.nombre) ? obra.programa.nombre : '',
          municipio: (obra.ubicacion
            && obra.ubicacion.municipio
            && obra.ubicacion.municipio.nombre)
            ? obra.ubicacion.municipio.nombre : '',
          localidad: (obra.ubicacion && obra.ubicacion.localidad)
            ? obra.ubicacion.localidad : '',
          ubicacion: (obra.ubicacion && obra.ubicacion.ubicacion)
            ? obra.ubicacion.ubicacion : '',
          latitud: (obra.ubicacion && obra.ubicacion.latitud)
            ? obra.ubicacion.latitud : '',
          longitud: (obra.ubicacion && obra.ubicacion.longitud)
            ? obra.ubicacion.longitud : '',
          beneficiados: (obra.impacto && obra.impacto.beneficiados)
            ? obra.impacto.beneficiados : '',
          unidadMetaFisica: (obra.impacto && obra.impacto.unidadMetaFisica)
            ? obra.impacto.unidadMetaFisica : '',
          cantidadMetaFisica: (obra.impacto && obra.impacto.metaFisica)
            ? obra.impacto.metaFisica : '',
          presupuestoAutorizado: {
            value: this.getDatosContrato(obra).presupuestoAutorizado,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          presupuestoModificado: {
            value: this.getDatosContrato(obra).presupuestoModificado,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          oficiosAutorizado: '',
          contratado: {
            value: this.getDatosContrato(obra).contratado,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          ejercido: {
            value: this.getDatosContrato(obra).ejercido,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          pagado: {
            value: this.getDatosContrato(obra).pagado,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          porcentajeAvanceProgramado: this.getDatosContrato(obra).porcentajeAvanceProgramado,
          porcentajeAvanceFinanciero: this.getDatosContrato(obra).porcentajeAvanceFinanciero,
          porcentajeAvanceFisico: this.getDatosContrato(obra).porcentajeAvanceFisico,
        }));

      return obrasFormateadasExcel;
    },
    getListaObrasFormateadasExcel() {
      const listaObrasActual = [];
      const listaObrasRangoFechas = [];

      this.getObrasFormateadasExcel.forEach((obra) => {
        listaObrasActual.push(obra);

        // const isBetween = this.$moment(obra.fecha)
        //   .isBetween(this.rangoFechas.inicial, this.rangoFechas.final, undefined, '[]');

        // if (isBetween) {
        //   listaObrasRangoFechas.push(...obra);
        // }
      });

      return this.seleccion === 'listadoActual' ? listaObrasActual : listaObrasRangoFechas;
    },
    getDetallesPresupuesto() {
      const presupuestos = JSON.parse(JSON.stringify(this.presupuestos));
      const detallesPresupuestos = [];
      presupuestos.forEach((presupuesto) => {
        presupuesto.detalles.forEach((detalle) => {
          const ampliaciones = detalle.modificaciones.filter((elem) => elem.tipo === 'AMPLIACIÓN')
            .reduce((acc, elem) => acc + elem.importe, 0);
          const reducciones = detalle.modificaciones.filter((elem) => elem.tipo === 'REDUCCIÓN')
            .reduce((acc, elem) => acc + elem.importe, 0);
          const pptoModificado = ampliaciones + reducciones + detalle.importe;
          const data = {
            fondo: presupuesto.fuente.nombre,
            clave: detalle.claveObra,
            obra: detalle.obra.meta,
            idObra: detalle.obra.id,
            presupuestoAutorizado: detalle.importe,
            presupuestoModificado: pptoModificado,
          };
          detallesPresupuestos.push(data);
        });
      });
      return detallesPresupuestos;
    },
    crearDatosDocumento() {
      const inicial = this.$moment(this.rangoFechas.inicial).format('DD-MM-YYYY');
      const final = this.$moment(this.rangoFechas.final).format('DD-MM-YYYY');
      const datosDocumento = [];
      datosDocumento.push(
        {
          value: 'PROGRAMA DE OBRAS',
          row: 1,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 1,
            col: 27,
          },
        },
      );
      if (this.seleccion === 'rangoFechas') {
        datosDocumento.push(
          {
            value: `${inicial} AL ${final}`,
            row: 2,
            col: 1,
            estilo: {
              font: {
                size: 16,
                bold: true,
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
            },
            combinar: {
              row: 2,
              col: 27,
            },
          },
        );
      }
      return datosDocumento;
    },
    getHeaders() {
      const headers = this.headersColumnas
        .map((header) => header.value)
        .sort((a, b) => a.orden - b.orden);
      return headers;
    },
    getColumnas() {
      const columnas = this.headersColumnas
        .map((columna) => columna.nombreColumna)
        .sort((a, b) => a.orden - b.orden);
      return columnas;
    },
    crearExcelObras() {
      const datosDocumento = this.crearDatosDocumento;
      const dataHeaders = this.getHeaders;
      const nombreDeColumnas = [...this.getColumnas];
      const bodyData = this.getListaObrasFormateadasExcel.length > 0
        ? this.getListaObrasFormateadasExcel : this.noData;
      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            filaInicio: filaInicioDatos,
            data: bodyData,
          },
        },
      };
      return data;
    },
  },

};
</script>

<style>

</style>
